var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"columns folio-headers"},_vm._l((_vm.folios),function(item,index){return _c('comparador-folio-header',{key:`folio-header-item-${index}`,staticClass:"is-pulled-left",attrs:{"folio":item,"esta-abierto":_vm.estaAbierto}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }